/**
 * White-label branding via frontend/.env (rebuild after change).
 *
 * Dev example (LMS):
 *   REACT_APP_BRAND_NAME=Learning Management System
 *   REACT_APP_BRAND_SHORT=LMS
 *   REACT_APP_BRAND_TAGLINE=LMS Platform
 *
 * Prod example (Dhwanisamskritam):
 *   REACT_APP_BRAND_NAME=Dhwanisamskritam
 *   REACT_APP_BRAND_SHORT=DHWANI
 *   REACT_APP_BRAND_TAGLINE=Dhwanisamskritam
 */

function clean(value, fallback) {
  const v = String(value ?? '').trim();
  return v || fallback;
}

export const BRAND_NAME = clean(process.env.REACT_APP_BRAND_NAME, 'Learning Management System');
export const BRAND_SHORT = clean(process.env.REACT_APP_BRAND_SHORT, 'LMS');
export const BRAND_TAGLINE = clean(process.env.REACT_APP_BRAND_TAGLINE, 'LMS Platform');
export const BRAND_FOOTER = clean(
  process.env.REACT_APP_BRAND_FOOTER,
  `© ${new Date().getFullYear()} ${BRAND_NAME}. Empowering knowledge through interaction.`
);
export const BRAND_LOGO_URL = clean(process.env.REACT_APP_BRAND_LOGO_URL, '');
